let ctx = null;

function getCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
}

function tone(freq, duration, type = 'sine', vol = 0.3, delay = 0) {
  try {
    const ac = getCtx();
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.connect(gain);
    gain.connect(ac.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(freq, ac.currentTime + delay);
    gain.gain.setValueAtTime(vol, ac.currentTime + delay);
    gain.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + delay + duration);
    osc.start(ac.currentTime + delay);
    osc.stop(ac.currentTime + delay + duration);
  } catch {}
}

export const sounds = {
  deal() {
    tone(800, 0.06, 'square', 0.15);
    tone(600, 0.06, 'square', 0.1, 0.05);
  },
  chip() {
    tone(1200, 0.05, 'square', 0.1);
    tone(900, 0.08, 'sine', 0.08, 0.04);
  },
  hit() {
    tone(700, 0.07, 'square', 0.12);
  },
  stand() {
    tone(400, 0.1, 'sine', 0.15);
    tone(350, 0.12, 'sine', 0.1, 0.08);
  },
  bust() {
    tone(300, 0.15, 'sawtooth', 0.2);
    tone(200, 0.25, 'sawtooth', 0.15, 0.12);
    tone(150, 0.3, 'sawtooth', 0.1, 0.25);
  },
  win() {
    [523, 659, 784, 1047].forEach((f, i) => tone(f, 0.18, 'sine', 0.25, i * 0.1));
  },
  blackjack() {
    [523, 659, 784, 1047, 1319].forEach((f, i) => tone(f, 0.2, 'sine', 0.3, i * 0.08));
    tone(1319, 0.4, 'sine', 0.2, 0.5);
  },
  lose() {
    [400, 320, 250].forEach((f, i) => tone(f, 0.2, 'sine', 0.2, i * 0.1));
  },
  push() {
    tone(440, 0.15, 'sine', 0.15);
    tone(440, 0.15, 'sine', 0.1, 0.2);
  },
  dealerReveal() {
    tone(350, 0.08, 'square', 0.1);
    tone(500, 0.12, 'sine', 0.15, 0.07);
  },
};
